export class Curriculum {
    Id: number;
    Description: string;
    IsActive: boolean;

    constructor(id = -1, description = 'default', isActive = true){
        this.Id = id;
        this.Description = description;
        this.IsActive = isActive;
    }
}



// WEBPACK FOOTER //
// ./src/app/main/models/curricula/curriculum.ts